import React, { useEffect, useState } from 'react'
import { useAppSelector } from 'app/hooks'
import { RootState, Floorplans, Analytics, FloorplansAnalytics, AnalyticsSource } from 'app/types'
import { AnalyticsLineChart } from 'views/AdminPage/Analytics/AnalyticsLineChart'
import { AnalyticsBarChart } from 'views/AdminPage/Analytics/AnalyticsBarChart'
import { AnalyticsTopChart } from 'views/AdminPage/Analytics/AnalyticsTopChart'
import * as moment from 'moment'

interface FloorplansAnalyticsTileProps {
    data: FloorplansAnalytics[],
    analytic: string,
}

export function FloorplansAnalyticsTile(props: FloorplansAnalyticsTileProps) {
    const { data, analytic } = props
    const [chartData, setChartData] = useState(null)

    useEffect(() => {
        /*
        const newData = [...data]
        let plans = {}
        for(let i = 0; i < data.length; i++) {
            plans[data[i].floorplanId] = data[i]
        }
        if(newData.length > 0) {
            // Add fake data
            let keys = Object.keys(plans)
            for(let i = 0; i < 100; i += 1) {
                // Pick random floorplan
                let randomIndex = Math.floor(Math.random()*keys.length)
                let randomKey = keys[randomIndex]
                let randomPlan = {...plans[randomKey]}
                let randomShift = -Math.floor(Math.random()*20)
                randomPlan.dateVisited = moment().subtract(randomShift, 'days')
                randomPlan.dateVisited = randomPlan.dateVisited.toDate().toISOString()

                let sources = Object.keys(AnalyticsSource).map((x) => AnalyticsSource[x])
                let randomSource = Math.floor(Math.random()*sources.length)
                randomPlan.source = sources[randomSource]

                // planMap[randomKey].push(randomPlan)
                newData.push(randomPlan)
            }
        }
        setChartData(newData)
        */
        setChartData(data)
    }, [])

    if (chartData == null) {
        return null
    }

    return <div className="analytics-tile">
        <AnalyticsTopChart
            title={analytic == Analytics.Favourites ? "Floorplan Favourites" : "Floorplan Views"}
            data={chartData}
            dataKey="name"
            filters={Object.keys(AnalyticsSource).map((x) => AnalyticsSource[x])}
            filterKey="source"
            color="var(--tertiary-mid)"
        />
    </div>
}